export default __webpack_public_path__ + "static/media/Tutti Frutti.d8aaa767.jpg";